import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress cross-origin "Script error." from third-party scripts (Stripe.js, Plaid SDK, etc.)
// These errors cannot be inspected due to browser same-origin policy and are not actionable.
// Using capture phase ensures this runs before CRA's error overlay listener.
window.addEventListener('error', (event) => {
  if (event.message === 'Script error.') {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
